"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventWhitelist = void 0;
var _ = require("lodash");
var DEFAULT_WHITELIST = [];
var EventWhitelist = /** @class */ (function () {
    function EventWhitelist() {
        var _this = this;
        this.get = function () {
            return _this.whitelist;
        };
        this.add = function (event_id) {
            _this.whitelist.push(event_id);
        };
        this.remove = function (event_id) {
            _this.whitelist = _.remove(_this.whitelist, function (id) { return String(id) === String(event_id); });
        };
        this.isWhitelisted = function (event_id) {
            return _.some(_this.whitelist, function (id) { return String(id) === String(event_id); });
        };
        this.whitelist = __spreadArray([], DEFAULT_WHITELIST, true);
    }
    EventWhitelist.INSTANCE = new EventWhitelist();
    return EventWhitelist;
}());
exports.EventWhitelist = EventWhitelist;
